export default {
  init() {
    // JavaScript to be fired on the example page page

    if (document.body.classList.contains('single-careers-form')) {
      fillTitleInput()
    }

    // Get the career form title and add it to the hidden field - for submission
    function fillTitleInput() {
      let field = document.querySelector('#js-job-title');
      let title = document.querySelector('#position-title');

      field.setAttribute('value', title.textContent);
    }

  },
  finalize() {
    // JavaScript to be fired on the example page page, after the init JS
  },
};
